export const createDivInBody = () => {
  const div = document.createElement("div");
  document.body.appendChild(div);

  return div;
};

export const blurActiveElement = () => {
  if (
    typeof document !== "undefined" &&
    document.activeElement &&
    document.activeElement.tagName !== "BODY" &&
    document.activeElement.blur
  ) {
    document.activeElement.blur();
  }
};
